import axios from 'axios';
import { apiUrl } from '../Config';


export const LoginApi = async (data) => {
    try {
        const response = await axios.post( `${apiUrl}/employee/login`,
            { userName: data.userName, password: data.password },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}


export const registerApi = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/register`,
            {
                type: data.type,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                mobile: data.mobile,
                password: data.password,
                acceptedTermsAt: data.acceptedTermsAt,
                isEmailVerified: data.isEmailVerified
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const freelancerRegisterApi = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/freelancers/register`,
            {
                type: data.type,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                mobile: data.mobile,
                password: data.password,
                acceptedTermsAt: data.acceptedTermsAt,
                isEmailVerified: data.isEmailVerified
            },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const sendEmailVerification = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/public/send-email-verification`,
            {
                email: data.email
            },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const confirmEmailVerification = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/public/confirm-email-verification`,
            {
                email: data.email,
                otp: data.otp
            },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const sendMobileVerification = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/public/send-mobile-verification`,
            { mobile: data.mobile },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const confirmMobileVerification = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/public/confirm-mobile-verification`,
            { mobile: data.mobile, otp: data.otp },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const forgotPasswordApi = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/forgot-password`,
            { email: data.email },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const resetPasswordApi = async (data) => {
    try {
        const response = await axios.post(
            `${apiUrl}/employee/reset-password`,
            {
                token: data.token,
                newPassword: data.newPassword
            },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const checkExistsApi = async (params) => {
    try {
        const response = await axios.get(`${apiUrl}/employee/public/check-exists`, { params });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}